{
  "labels": {
    "potrditevI": "Verifica dell'identità",
    "vnesiKodo": "Inserisci il codice generato nell'autenticatore",
    "napacnaKoda": "Il codice inserito non è corretto, riprova"
  },
  "buttons": {
    "potrdiK": "Conferma"
  },
  "obvestila": {
    "napakaKode": "Autenticazione non riuscita! Il codice inserito non è corretto",
    "avtUspesna": "Autenticazione riuscita",
    "napaka": "Autenticazione non riuscita!",
    "praznoPolje": "Il campo del codice non può essere vuoto!"
  }
}